import React from 'react';
import LeaveRequestForm from '@/components/Staff/LeaveRequestForm';

const MyLeaveRequestPage = () => {
  return (
    <div className="p-6">
      <LeaveRequestForm />
    </div>
  );
};

export default MyLeaveRequestPage;
